<template>
   <div :class="theme" class="notice mt-2 p-4" data-cy="notice" v-if="heading || description">
      <div class="mb-3 flex items-center only:mb-0">
         <IconInfoCircle v-if="theme === 'info'" class="mr-2 inline-block size-4 shrink-0 text-info-dark" />
         <IconAlert v-if="theme === 'warn'" class="mr-2 inline-block size-4 shrink-0" />
         <component :is="headingElementType" class="text-bolder inline-block" data-cy="notice-heading">{{
            heading
         }}</component>
      </div>

      <RichTextRenderer v-if="description" :document="description" class="text-regular" data-cy="notice-description" />
   </div>
</template>

<script setup lang="ts">
import type { RichText } from "@/types";

interface NoticeProps {
   theme?: "info" | "warn";
   heading: string;
   headingLevel?: number;
   description?: RichText;
}

// Props
// ------------------------------------
const props = withDefaults(defineProps<NoticeProps>(), {
   theme: "info",
   headingLevel: 4,
});

// Computed
// ------------------------------------

// We want to use <h> tag if there is description provided, otherwise use <p> tag
const headingElementType = props.description ? `h${props.headingLevel}` : "p";
</script>
<style lang="scss" scoped>
.info {
   @apply bg-grey-10;
}

.warn {
   @apply bg-sand-10;
}
</style>
